/*
 * @Author: jin.li 1754611189@qq.com
 * @Date: 2024-12-26 14:33:41
 * @LastEditors: jin.li 1754611189@qq.com
 * @LastEditTime: 2025-06-30 10:32:06
 * @FilePath: \cbest-welfare-erp-h5\src\components\AreaSelect.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useState, useEffect } from 'react'
import { Cascader, Spin } from 'antd'
import service from '../@services'
import { treeDataTranslate } from '../@utils/index'
export default function CategorySelect(props) {
  const {
    style = {},
    disabled = false,
    onChange = () => { },
    deliveryArea = [],
    changeOnSelect = true,
    multiple = true,
    isCounty = false,
    placeholder = '请选择区域'
  } = props
  const [options, setOptions] = useState([]);
  const [spinning, setSpinning] = useState(false);
  const [orginOptions, setOrginOptions] = useState([]);
  const [defaultValue, setDefaultValue] = useState([]);
  useEffect(() => {
    setSpinning(true)
    service.common.getArea().then((res) => {
      setSpinning(false)
      if (Array.isArray(res)) {
        let areaFilterList = res || []
        if (!isCounty) {
          areaFilterList = areaFilterList.filter(item => item.areaType !== 'county')
        }
        // areaFilterList = areaFilterList.filter((item) => ((item.areaCode + '').indexOf('50') === 0 || (item.areaCode + '').indexOf('51') === 0 || (item.areaCode + '').indexOf('53') === 0 || (item.areaCode + '').indexOf('52') === 0))
        const areaList = (areaFilterList || []).map(item => {
          if (isCounty) {
            if (item.areaType !== 'county') {
              item.isLeaf = false
            }
          } else {
            if (item.areaType !== 'city') {
              item.isLeaf = false
            }
          }
          return item
        })
        setOrginOptions(areaList);
        const treeAreaList = treeDataTranslate([...areaList])
        setOptions(treeAreaList)
      }
    }).catch(() => {
      setSpinning(false)
    })
    return () => { }
  }, [])
  const findAllParent = (code, codelist) => {
    codelist.unshift(code);
    let index
    if (!isCounty) {
      index = orginOptions.findIndex(item => item.areaCode === Number(code))
    } else {
      index = orginOptions.findIndex(item => item.areaCode === code)
    }
    if (index > -1 && orginOptions[index].parentAreaCode) {
      findAllParent(orginOptions[index].parentAreaCode, codelist)
    }
  };
  useEffect(() => {
    if (options.length) {
      const deliveryAreaMap = deliveryArea.map(code => {
        const codelist = []
        let index
        if (!isCounty) {
          index = orginOptions.findIndex(item => item.areaCode === Number(code))
        } else {
          index = orginOptions.findIndex(item => item.areaCode === code)
        }
        codelist.unshift(code);
        if (index > -1 && orginOptions[index].parentAreaCode) {
          findAllParent(orginOptions[index].parentAreaCode, codelist)
        }
        return codelist
      })
      setDefaultValue(deliveryAreaMap)
    }
  }, [options, deliveryArea])
  return <Spin spinning={spinning}>
    <Cascader
      disabled={disabled}
      key={defaultValue}
      style={style}
      defaultValue={defaultValue}
      options={options}
      multiple={multiple}
      placeholder={placeholder}
      fieldNames={{ label: 'areaName', value: 'areaCode', children: 'children' }}
      onChange={onChange}
      changeOnSelect={changeOnSelect} />
  </Spin>
}
